function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import omit from 'lodash.omit';
import queryString from 'query-string';
import activeFrameUrl from "../get-frame-url.js";
var BaseFrameController = /*#__PURE__*/function () {
  function BaseFrameController(spawnElement, authToken, uri, config) {
    _classCallCheck(this, BaseFrameController);
    this.spawnElement = spawnElement;
    var queryParams = queryString.stringify({
      no_navigation: true,
      config: config
    });
    this.url = "".concat(activeFrameUrl(), "/?auth_token=").concat(authToken, "/#").concat(uri, "?").concat(queryParams);
    this._init();
    this.eventListeners = [];
  }
  _createClass(BaseFrameController, [{
    key: "_init",
    value: function _init() {
      var _this = this;
      if (!['interactive', 'complete'].includes(document.readyState)) {
        document.addEventListener('readystatechange', function () {
          if (['interactive', 'complete'].includes(document.readyState)) _this._spawn();
        });
      } else this._spawn();
    }
  }, {
    key: "_spawn",
    value: function _spawn() {
      var iframe = document.createElement('iframe');
      iframe.src = this.url;
      iframe.frameBorder = '0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.position = 'absolute';
      var spawnElement = document.querySelector(this.spawnElement);
      if (!spawnElement) console.error("[Storyteq platform integration] Failed to find target element ".concat(this.spawnElement));
      spawnElement.style.position = 'relative';
      spawnElement.appendChild(iframe);
      this.frame = iframe;
      this._initiatePageListeners();
    }
  }, {
    key: "_initiatePageListeners",
    value: function _initiatePageListeners() {
      var _this2 = this;
      var receiveMessage = function receiveMessage(e) {
        try {
          var messagePayload = JSON.parse(e.data);
          _this2.eventListeners.forEach(function (_ref) {
            var event = _ref.event,
              cb = _ref.cb;
            var eventPayload = omit(messagePayload, ['event']);
            if (event === messagePayload.event) cb(eventPayload);
          });
        } catch (error) {
          console.error('[Storyteq platform integration] Failed to parse incoming frame message;', e.data);
        }
      };
      window.addEventListener('message', receiveMessage, false);
    }
  }, {
    key: "on",
    value: function on(event, cb) {
      if (!this.availableEvents.includes(event)) console.error("[Storyteq platform integration] Trying to listen to unsupported event \"".concat(event, "\""));
      this.eventListeners.push({
        event: event,
        cb: cb
      });
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.frame) return;
      this.eventListeners = [];
      try {
        this.frame.parentElement.removeChild(this.frame);
      } catch (error) {}
    }
  }]);
  return BaseFrameController;
}();
export default BaseFrameController;